import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import './UserPagination.css'

class UserPagination extends Component {
    render() {
        return (
            <div className="pagination-div">
                <div className={`pagination ${this.props.className}`}>
                    <ReactPaginate previousLabel={"‹"}
                                   nextLabel={"›"}
                                   breakLabel={<a>...</a>}
                                   breakClassName={"ellipsis disabled"}
                                   forcePage={+(this.props.page)}
                                   onPageChange={this.props.handlePageChange}
                                   pageCount={this.props.total_pages}
                                   marginPagesDisplayed={1}
                                   pageRangeDisplayed={3}
                                   containerClassName={"pagination"}
                                   subContainerClassName={"pages pagination"}
                                   activeClassName={"active"}
                    />
                </div>
            </div>
        );
    }

}

export default UserPagination;



// WEBPACK FOOTER //
// ./src/user-search/components/UserPagination.js